import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { DurationFormatter } from './durationFormatter';
import { LanguageString } from './time-label-map';

@Pipe({
    name: 'duration',
})
@Injectable({ providedIn: 'root' })
export class DurationPipe implements PipeTransform {
    transform(value: number | number[], showSeconds: boolean = false, showMinutes: boolean = true, convertFactor: number = 1, language: LanguageString = 'en'): string {
        return DurationFormatter.transform(value, showSeconds, showMinutes, convertFactor, language);
    }
}
